import { Button } from "components/atoms/button/button";
import styled, { keyframes } from "styled-components";
import { zIndex } from "styles/constants/zIndex";

export const JoinClassWrapper = styled.div`
  position: relative;
  flex-shrink: 0;
  display: flex;
  gap: 16px;
`;

export const StyledButton = styled(Button)`
  padding: 12px 14px;
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
  position: relative;
`;

export const Tooltip = styled.div`
  font-size: ${({ theme }) => theme.fontSizes["sm"]};
  font-weight: bold;
  line-height: 22px;
  border-radius: 6px;
  width: 170px;
  padding: 16px;
  position: absolute;
  top: 60px;
  left: 12px;
  z-index: ${zIndex.modal};
  overflow: visible;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
    rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,
    rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
  &:after {
    content: " ";
    position: absolute;
    bottom: 100%;
    left: 20%;
    margin-left: -5px;
    border-width: 10px;
    border-style: solid;
    border-color: transparent transparent ${({ theme }) => theme.colors.white}
      transparent;
  }
`;

export const StyledTooltipButton = styled(Button)`
  font-size: ${({ theme }) => theme.fontSizes["xs"]};
  padding: 0;
  height: 30px;
`;

const pulseRed = keyframes`
0% {
  transform: scale(0.95);
  box-shadow: 0 0 0 0 rgba(255, 82, 82, 0.7);
}

70% {
  transform: scale(1);
  box-shadow: 0 0 0 10px rgba(255, 82, 82, 0);
}

100% {
  transform: scale(0.95);
  box-shadow: 0 0 0 0 rgba(255, 82, 82, 0);
}
`;

export const BlobRed = styled.div`
  background: red;
  box-shadow: 0 0 0 0 rgba(255, 82, 82, 1);
  animation: ${pulseRed} 3s infinite;
  border-radius: 50%;
  margin: 10px;
  height: 14px;
  width: 14px;
  transform: scale(1);
  position: absolute;
  right: -14px;
  top: -14px;
`;
